/*
 * Copyright (c) Nexign, JSC, 2020-2021.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @author Aleksandr Perkhunov
 * @version 1.11.0
 * @since 1.10.0
 */

import { Button, LinkBlock } from '../../../components/common';
import { LinkContainerStyled } from '../../../components/common/LinkBlock/styled/LinkStyled';
import { IPageProductsChangeModalTranslation } from '../../../modules/internationalization/types/pages/products';
import {
    ModalPopupContainerStyled,
    ModalPopupControlContainer,
    ModalPopupTextStyled,
    ModalPopupTitleStyled,
} from '../../../modules/modal/components/styled/ModalStyled';

interface ITariffAndServicesRegionChangeModalProps {
    onAgree: () => void;
    onDisagree: () => void;
    translation: IPageProductsChangeModalTranslation;
}

export type TTariffAndServicesRegionChangeModal = ITariffAndServicesRegionChangeModalProps;

export const ProductsChangeModal = (props: TTariffAndServicesRegionChangeModal) => {
    const {
        onAgree,
        onDisagree,
        translation,
    } = props;

    return (
        <ModalPopupContainerStyled
            data-component={'modal-popup'}
            data-name={'products-region-change-modal'}
            width="490px">
            <ModalPopupTitleStyled data-name='modal-popup-title'>
                {translation.title}
            </ModalPopupTitleStyled>
            <ModalPopupTextStyled data-name='modal-popup-notice'>
                {translation.notice}
            </ModalPopupTextStyled>
            <ModalPopupTextStyled data-name='modal-popup-answer'>
                {translation.answer}
            </ModalPopupTextStyled>

            <ModalPopupControlContainer>
                <Button dataName="regionChangeModalBtnAgree" onClick={onAgree}>
                    {translation.agreeBtn}
                </Button>
                <LinkContainerStyled onClick={onDisagree}>
                    <LinkBlock data-name='close-button'>
                        {translation.cancelBtn}
                    </LinkBlock>
                </LinkContainerStyled>
            </ModalPopupControlContainer>
        </ModalPopupContainerStyled>
    );
};

export default ProductsChangeModal;
